import {Component, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Data} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ITEMS_PER_PAGE, PAGE_SIZE_OPTIONS} from '@app/shared';
import {DialogService} from '@shared/confirm-dialog/dialog.service';
import {exportFileData} from '@shared/util/export-file';
import {IQrcreate} from '@entities/qr-code/qr-code.model';
import {QrCodeService} from '@entities/qr-code/qr-code.service';

@Component({
  selector: 'app-qr-code-detail',
  templateUrl: './qr-code-detail.component.html',
})
export class QrCodeDetailComponent implements OnInit {
  displayedColumns: string[] = [
    'code',
    'lanQuetCuoi',
    'solanQuet',
    'trangThai',
    'action',
  ];
  ELEMENT_DATA: IQrcreate[];
  dataSource: any;
  totalItems: any;
  itemsPerPage: any;
  pageSizeOptions: number[];
  page = 1;
  noData: boolean;
  isLoading = true;
  qrCodeDetail: any;

  constructor(
    private qrCodeService: QrCodeService,
    private activatedRoute: ActivatedRoute,
    private confirmService: DialogService,
    private translate: TranslateService,
  ) {
    this.ELEMENT_DATA = [];
    this.dataSource = new MatTableDataSource([]);
    this.itemsPerPage = ITEMS_PER_PAGE;
    this.pageSizeOptions = PAGE_SIZE_OPTIONS;
  }

  ngOnInit() {
    this.loadAll();
  }

  loadAll() {
    this.activatedRoute.data.subscribe(({data}: Data) => {
      this.fillData(data);
    });
  }

  loadPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.loadAll();
  }

  exportFile(item: any, isPdf: boolean): void {
    if (isPdf) {
      this.qrCodeService.exportPdfQuery(item.id).subscribe((res) => {
        exportFileData(res.body, res.headers);
      });
    } else {
      this.qrCodeService.exportQuery(item.code).subscribe((res) => {
        exportFileData(res.body, res.headers);
      });
    }
  }

  changeStatusCode(qrCode: any, status: string) {
    const titleKey =
      status === 'ACTIVE'
        ? 'entities.qr-code.qr-code-detail.Kích hoạt mã QR_dialog_title'
        : 'entities.qr-code.qr-code-detail.Hủy mã QR_dialog_title';
    const contentKey =
      status === 'ACTIVE'
        ? 'entities.qr-code.qr-code-detail.Bạn muốn kích hoạt tất cả mã QR của lần tạo này?_dialog_content'
        : 'entities.qr-code.qr-code-detail.Bạn muốn hủy tất cả mã QR của lần tạo này?_dialog_content';

    this.confirmService
      .confirm(
        this.translate.instant(titleKey),
        this.translate.instant(contentKey),
      )
      .subscribe((res) => {
        if (res) {
          this.qrCodeService
            .updateTBCode(qrCode.id, status)
            .subscribe((response) => {
              this.fillData(response.body);
            });
        }
      });
  }

  fillData(data: any): void {
    this.isLoading = false;
    this.qrCodeDetail = data;
    this.totalItems = data.tbCodeDetails.length;
    const startIndex = this.itemsPerPage * (this.page - 1);
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.totalItems);
    this.ELEMENT_DATA = data.tbCodeDetails.slice(startIndex, endIndex);
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    this.noData = data.tbCodeDetails.length === 0;
  }

  getStatusLabel(status: string): string {
    const map: Record<string, string> = {
      NEW: 'entities.qr-code.qr-code.Mới_status',
      ACTIVE: 'entities.qr-code.qr-code.Kích hoạt_status',
      EXPIRED: 'entities.qr-code.qr-code.Hết hạn_status',
      CANCELED: 'entities.qr-code.qr-code.Hủy_status',
    };
    const key = map[status] || 'entities.qr-code.qr-code.Chưa cập nhật_status';
    return this.translate.instant(key);
  }
}
